export default __webpack_public_path__ + "static/media/t_19_2076_colorized.4323fb43.png";